export const inr = (n) => (n === null || n === undefined || isNaN(n) ? "—" : "₹" + Math.round(Number(n)).toLocaleString("en-IN"));
export const readB64 = (file) => new Promise((res, rej) => { const r = new FileReader(); r.onload = () => res(r.result); r.onerror = rej; r.readAsDataURL(file); });
export const CAT_ORDER = ["online", "dining", "travel", "fuel", "groceries", "movies", "utilities", "international", "other"];
export const METHOD_LABEL = {
  official_sources: "From official issuer pages & MITC/KFS",
  customer_upload: "From uploaded official benefit document",
  ai_research: "AI research — issuer site could not be read",
};
export const errMsg = (e, d) => e?.response?.data?.detail || d;
export const cardTitle = (issuer, name) => {
  const w = (issuer || "").split(" ")[0].toLowerCase();
  return w && (name || "").toLowerCase().includes(w) ? name : `${issuer || ""} ${name || ""}`.trim();
};
